// extracted by css-extract-rspack-plugin
export default {"Panel":"CollapsibleRegion-module__Panel__a8mYl","FindableContent":"CollapsibleRegion-module__FindableContent__Vj5HH"};